import { StaticQuery, graphql } from "gatsby";
import React from "react";

import {
  Section,
  Image,
  Card,
  Header2,
  Underlined,
  Paragraph,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Hero";
import { getSize } from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

// import CitySolarBg from "images/city_solar_panels.png";

export const Commercial = () => (
  <Section>
    <StaticQuery
      query={graphql`
        query ApplicationsCommercialHeroImageQuery {
          file(relativePath: { eq: "city_solar_panels.png" }) {
            ...HeroImage
          }
        }
      `}
      render={({ file }) => (
        <Image
          alt=""
          css={`
            + picture > img,
            img {
              object-position: 72% 50%;
              @media screen and (min-width: ${getSize("tablet720")}) {
                object-position: 71% 50%;
              }
              @media screen and (min-width: ${getSize("tablet768")}) {
                object-position: 70% 50%;
              }
            }
          `}
          file={file}
        />
      )}
    />
    <Card
      css={`
        @media screen and (min-width: ${getSize(
            "default"
          )}) and (max-width: 479px) {
          padding: 31px 38px 39px 38px;
        }
        @media screen and (min-width: ${getSize(
            "mobile480"
          )}) and (max-width: 719px) {
          padding: 32px 52px 43px 46px;
        }
        @media screen and (min-width: ${getSize(
            "tablet720"
          )}) and (max-width: 959px) {
          width: 350px;
        }
        @media screen and (min-width: ${getSize(
            "tablet960"
          )}) and (max-width: 1199px) {
          padding: 32px 38px 34px 42px;
          width: 355px;
        }
        @media screen and (min-width: ${getSize(
            "desktop1200"
          )}) and (max-width: 1919px) {
          padding: 45px 48px 41px 50px;
          width: 498px;
        }
        @media screen and (min-width: ${getSize("desktop1920")}) {
          padding-right: 60px;
          width: 583px;
        }
      `}
    >
      <Header2
        id="commercial"
        css={`
          @media screen and (min-width: ${getSize("desktop1200")}) {
            font-size: 48px;
            line-height: 58px;
          }
        `}
      >
        {"Commercial"}
        <Underlined />
      </Header2>
      <Paragraph
        css={`
          @media screen and (min-width: ${getSize(
              "tablet720"
            )}) and (max-width: 767px) {
            margin-top: 16px;
          }
          @media screen and (min-width: ${getSize(
              "tablet960"
            )}) and (max-width: 1199px) {
            margin-top: 24px;
          }
          @media screen and (min-width: ${getSize(
              "desktop1200"
            )}) and (max-width: 1919px) {
            font-size: 20px;
            line-height: 31px;
            margin-top: 20px;
          }
        `}
      >
        {
          "Having a commercial microgrid enables businesses to save money on their electricity bills and keep the power on during a grid failure, which saves money and offers security."
        }
      </Paragraph>
    </Card>
  </Section>
);
